import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import { ArrowForward } from "@mui/icons-material";

const HeroSection = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        py: { xs: 10, md: 14 },
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <Typography
            variant="h2"
            textAlign="center"
            sx={{ color: "#ffffff", fontWeight: 900, letterSpacing: "-0.02em" }}
          >
            One System for Your Whole Evangelism Ministry.
          </Typography>

          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              color: "rgba(255,255,255,0.75)",
              maxWidth: 800,
              mx: "auto",
              mt: 2,
            }}
          >
            PATHWAYS helps Ministry Leaders connect individual evangelistic efforts into intentional pathways. So leaders can see
            the big picture, coordinate the next steps and improve the outreach strategy.
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            sx={{ mt: 4 }}
          >
            <Button
              variant="contained"
              sx={{
                background: "#4ade80",
                color: "#0f172a",
                borderRadius: "9999px",
                px: 4,
                py: 1.5,
                fontSize: "1rem",
                boxShadow: "0px 10px 30px rgba(0,0,0,0.35)",
                "&:hover": { background: "#22c55e" },
                textTransform: "none",
                fontWeight: 900,
              }}
              size="large"
              href="/register/"
              endIcon={<ArrowForward />}
            >
              Get Started with PATHWAYS
            </Button>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
};

export default HeroSection;